import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface RemoveMfaSecretRequestModel {
	readonly password: string;
	readonly mfaCode: string;
}

export const useRemoveMfaSecret = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<undefined>, RemoveMfaSecretRequestModel> = requestModel => {
		return http<undefined, RemoveMfaSecretRequestModel>({
			method: "POST",
			url: "/mfa/remove",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
